import React from 'react';

import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Footer from './components/Footer';
import Home from './pages/Home';
import Sponsorship from './pages/Sponsorship';
import PastCompetition2016 from './pages/past_competitions/PastCompetition2016';
import PastCompetition2017 from './pages/past_competitions/PastCompetition2017';
import PastCompetition2018 from './pages/past_competitions/PastCompetition2018';
import PastCompetition2019 from './pages/past_competitions/PastCompetition2019';
import Contact from './pages/Contact';

export default function App() {
  return (
    <Router>
      <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/sponsorship" component={Sponsorship} />
        <Route exact path="/past-competitions/2016" component={PastCompetition2016} />
        <Route exact path="/past-competitions/2017" component={PastCompetition2017} />
        <Route exact path="/past-competitions/2018" component={PastCompetition2018} />
        <Route exact path="/past-competitions/2019" component={PastCompetition2019} />
        <Route exact path="/contact" component={Contact} />
      </Switch>
      <Footer />
    </Router>
  );
}